import React, { useRef, useState } from "react";

const FAQ = () => {
	const data = [
		{
			id: 1,
			question: "How can I buy the NFT",
			answer:
				"If you already have an account with a cryptocurrency exchange, you can purchase Solana on it and transfer your crypto to your Phantom wallet. If you don't already have a crypto exchange account, Binance are good options for beginners. Link your Phantom to an NFT Marketplace like Magic Eden. (Phantom is an Solana wallet that can be accessed using a Chrome extension or a mobile app.) Choose the NFT and make sure you have SOL to cover fees.  ",
		},
		{
			id: 2,
			question: "How many NFTs in the collection",
			answer: "444 in the collection",
		},
		{
			id: 3,
			question: "When is the mint date",
			answer: "July 30",
		},
		{
			id: 4,
			question: "What is the price",
			answer: "Public and WL 0.2 SOL",
		},
		{
			id: 5,
			question: "How can I get Whitelisted?",
			answer: "Check the discord",
		},
	];

	const [toggle, setToggle] = useState(false);

	const clicked = (id) => {
		if (toggle === id) {
			return setToggle(null);
		}
		setToggle(id);
	};
	return (
		<div
			className="max-w-7xl mx-auto flex items-center flex-col pt-20"
			id="faq"
			data-aos="fade-up"
		>
			<h1 className="text-white text-6xl font-bold"> FAQ</h1>
			{data.map((item) => {
				return (
					<div
						className="border-b border-gray-400 p-5 m-5 w-full  text-white"
						onClick={() => clicked(item.id)}
						key={item.id}
					>
						<div className="flex">
							<div className="text-lg font-bold flex-1">{item.question}</div>
							<div>
								{toggle === item.id ? (
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fill-rule="evenodd"
										clip-rule="evenodd"
									>
										<path
											fill="#ffff"
											d="M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm-6.5 10h13v1h-13v-1z"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										xmlns="http://www.w3.org/2000/svg"
										fill-rule="evenodd"
										clip-rule="evenodd"
									>
										<path
											fill="#ffff"
											d="M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm.5 10h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6z"
										/>
									</svg>
								)}
							</div>
						</div>
						<div
							className={`${
								toggle === item.id ? "h-[7.4rem]    lg:h-36" : "h-0"
							} lg:overflow-hidden transition-all duration-700 overflow-scroll`}
						>
							<p className="lg:text-lg text-sm pt-2 text-gray-300">
								{item.answer}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default FAQ;
